import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, logInWithEmailAndPassword, signInWithGoogle, sendPasswordReset } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);

  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (user) {
      navigate("/dashboard");
    }
  }, [user, loading]);

  return (
    <div className="login">
      <div className="login__container">
        <img src="scc.png" style={{ width: "100%" }} />
        <input
          placeholder="email"
          required
          type="email"
          onChange={(event) => setEmail(event.target.value)}
        ></input>
        <input
          placeholder="password"
          required
          type="password"
          onSubmit={() => handleLogin(email, password)}
          onChange={(event) => setPassword(event.target.value)}
        ></input>
        <button onClick={() => handleLogin(email, password)}>Sign In</button>
        <button onClick={() => signInWithGoogle()}>Sign In with Google</button>
        <div
          className="passreset"
          onClick={async () => {
            console.log(email);
            if (email.includes("@sandccgroup.com")) {
              try {
                sendPasswordReset(email);
              } catch (error) {
                if (error.message.includes("invalid-email")) {
                  alert("Please enter a valid S&CC Group Email");
                }
                console.log(error.message);
                alert(error.name);
              }
            } else {
              console.error(error);
              alert("Please enter a valid email.");
            }
          }}
        >
          Reset Password
        </div>
      </div>
    </div>
  );
};

const handleLogin = async (email, password) => {
  if (email.includes("@sandccgroup.com")) {
    try {
      logInWithEmailAndPassword(email, password);
    } catch (e) {
      if (e.includes("wrong-password")) {
        alert(`Incorrect Password for user ${email}`);
      } else if (e.includes("user-not-found")) {
        alert(`${email} is not a valid member of S&CC group.`);
      } else {
        alert(e);
      }
    }
  } else {
    alert("Please enter a valid S&CC Group email and password.");
  }
};

export default Login;
